<template>
  <div class="form-group">
    <label :for="id" class="control-label">Add strategies</label>
    <StrategiesTypeahead :id="id" @selected="addStrategy" />
    <ul class="list-group">
      <li
        class="list-group-item"
        v-for="(s, index) of selectedInternal"
        :key="s">
        <span>
          <router-link
            v-if="strategiesMap[s]"
            target="_blank"
            :to="{name: 'StrategyDetailPage', params: {slugOrUuid: strategiesMap[s].slug}}">{{ strategiesMap[s].title || s }}</router-link>
          <template v-else>{{ s }}</template>
        </span>
        <a
          class="remove text-danger"
          role="button"
          :aria-label="`Remove strategy ${strategiesMap[s] && strategiesMap[s].title || s}`"
          @click="remove(index)">
          <i class="fa fa-times"/>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import StrategiesTypeahead from './StrategiesTypeahead'

export default {
  name: 'SelectStrategies',
  components: { StrategiesTypeahead },
  props: {
    id: {
      type: String,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    },
    strategiesMap: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedInternal: this.selected || []
    }
  },
  methods: {
    addStrategy({ uuid }) {
      if (!uuid || this.selected.includes(uuid)) {
        return
      }
      this.selectedInternal = [...this.selectedInternal, uuid]
      this.$emit('update:selected', this.selectedInternal)
      this.$emit('add', uuid)
    },
    remove(i) {
      this.selectedInternal.splice(i, 1)
      this.$emit('update:selected', [...this.selectedInternal])
    },
    sequenceChanged(evt) {
      if (evt.moved) {
        this.$emit('update:selected', [...this.selectedInternal])
      }
    }
  },
  watch: {
    selected(newValue) {
      this.selectedInternal = newValue || []
    }
  }
}
</script>

<style lang="less" scoped>
.input-group {
  margin-bottom: 1em;
}
.list-group-item {
  display: flex;
  span {
    flex: 1 1 auto;
  }
  .remove {
    flex: 0 0 auto;
  }
}
</style>
